import LanguageSwitcher from "@/components/common/LanguageSwitcher";
import ThemeToggle from "@/components/common/ThemeToggle";
import { HomeIcon } from "@heroicons/react/24/outline";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Link, Outlet } from "react-router-dom";

const AuthLayout = () => {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-gray-50 dark:bg-gray-900">
      <header className="flex h-16 items-center justify-between px-6 md:px-8">
        <div className="flex items-center">
          <Link
            to="/"
            className="flex items-center hover:opacity-80 transition-opacity"
          >
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className="flex items-center"
            >
              <img src="/logo.svg" alt={t("app.name")} className="h-8 w-auto" />
              <span className="ml-2 text-xl font-bold text-primary-600 dark:text-primary-400">
                {t("app.name")}
              </span>
            </motion.div>
          </Link>
        </div>
        <div className="flex items-center space-x-4">
          {/* Home Button */}
          <Link
            to="/"
            className="rounded-full p-2 text-gray-500 hover:bg-gray-100 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-gray-200"
            aria-label={t("nav.home")}
          >
            <HomeIcon className="h-5 w-5" />
          </Link>

          <LanguageSwitcher />
          <ThemeToggle />
        </div>
      </header>

      <main className="flex flex-1 items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="w-full max-w-md"
        >
          <Outlet />
        </motion.div>
      </main>

      <footer className="py-4 text-center text-sm text-gray-500 dark:text-gray-400">
        <p>
          © {new Date().getFullYear()} Gnzabe. {t("common.allRightsReserved")}
        </p>
      </footer>
    </div>
  );
};

export default AuthLayout;
